import React, { createContext, useState, useEffect } from "react";

// Définition des types pour le contexte
interface PatientContextType {
  patientInfo: {
    firstName: string;
    lastName: string;
    patientId: number;
  } | null;
  setPatientInfo: (
    info: { firstName: string; lastName: string; patientId: number } | null
  ) => void;
}

// Création du contexte
export const PatientContext = createContext<PatientContextType | undefined>(
  undefined
);

// Fournisseur du contexte
export const PatientProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [patientInfo, setPatientInfo] = useState<
    PatientContextType["patientInfo"]
  >(() => {
    // Charger les données depuis le localStorage au démarrage
    const savedPatientInfo = localStorage.getItem("patientInfo");
    return savedPatientInfo ? JSON.parse(savedPatientInfo) : null;
  });

  useEffect(() => {
    // Sauvegarder dans le localStorage à chaque changement de patientInfo
    if (patientInfo) {
      localStorage.setItem("patientInfo", JSON.stringify(patientInfo));
    } else {
      localStorage.removeItem("patientInfo"); // Supprimez si aucune donnée n'est présente
    }
  }, [patientInfo]);

  return (
    <PatientContext.Provider value={{ patientInfo, setPatientInfo }}>
      {children}
    </PatientContext.Provider>
  );
};
